import { render } from "./CalenderView.vue?vue&type=template&id=bfe009a0&scoped=true"
import script from "./CalenderView.vue?vue&type=script&lang=js"
export * from "./CalenderView.vue?vue&type=script&lang=js"

import "./CalenderView.vue?vue&type=style&index=0&id=bfe009a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe009a0"]])

export default __exports__